exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "*[data-v-4d72f550],h1[data-v-4d72f550]{text-transform:none}*[data-v-4d72f550]{font-family:Arial,Helvetica}.label[data-v-4d72f550]{font-weight:400;font-size:.9rem}", ""]);

// exports
